import React, { useEffect } from "react";
import CollapsibleNavbar from "./ReservedAreaDashboard/CollapseNavbar";
import { useTranslation } from "react-i18next";

export function NavbarContent() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get("lang");
    if (lang) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage("it");
    }
  }, [i18n]);
  return (
    <div style={{ padding: "20px" }}>
      <CollapsibleNavbar
        isDrawerOpen={true}
        toggleDrawer={() => {
          window.parent.postMessage(
            {
              event_id: "hideCollapseNavbar",
            },
            "*"
          );
        }}
      />
    </div>
  );
}
